import React from 'react';
import { FadeIn, Button } from './Shared';
import { BatteryWarning } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center px-4 py-20 overflow-hidden" data-id="element-49">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-toxic/5 rounded-full blur-[120px] pointer-events-none" data-id="element-50" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-51">
        <FadeIn data-id="element-52">
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-toxic/30 bg-toxic/10 text-toxic text-sm font-bold tracking-widest uppercase mb-8" data-id="element-53">
            <BatteryWarning size={16} className="animate-pulse" data-id="element-54" />
            <span data-id="element-55">The 21-Day Protocol</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-56">
          <h1 className="text-5xl md:text-7xl font-black uppercase leading-[1.1] mb-6" data-id="element-57">
            The Vape-to-Zero <br className="hidden md:block" data-id="element-58" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-toxic to-green-300" data-id="element-59">
              Blueprint
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-60">
          <h2 className="text-xl md:text-2xl font-display font-bold text-neutral-400 mb-12 max-w-3xl mx-auto leading-tight" data-id="element-61">
            The 21-Day "Nic-Salt Ladder" to Kill the Disposable Addiction
            Forever.
            <span className="block mt-2 text-white" data-id="element-62">
              Stop the 3 AM "Dead Battery" panic and reclaim your lungs without
              the cold-turkey crash.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-63">
          <div className="bg-neutral-900/80 border border-neutral-800 p-6 md:p-8 text-left max-w-2xl mx-auto mb-12 relative overflow-hidden" data-id="element-64">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-toxic" data-id="element-65" />
            <p className="text-lg leading-relaxed text-neutral-300" data-id="element-66">
              <strong className="text-white" data-id="element-67">You know the feeling.</strong> It's
              midnight, you're scrolling in bed, and you reach for that plastic
              stick. You take a draw, and the blue light blinks. Twice. It's
              dead.
            </p>
            <p className="text-lg leading-relaxed text-neutral-300 mt-4" data-id="element-68">
              Suddenly, you aren't a relaxed adult—you're a frantic addict
              shaking a piece of flavored plastic, blowing into the charging
              port, hoping for one last chemical hit of "Icy Grape." This is the
              Disposable Trap. It's expensive, it's exhausting, and it's
              designed to keep you hooked until your lungs give out.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-69">
          <Button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-70">
            Get The Blueprint Now
          </Button>
        </FadeIn>
      </div>
    </section>;
}